export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/agency_page_perseus/brief_sent_illustration.fa231e2.svg";